import Logo from "@/components/Logo";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#050505] py-12 px-6 sm:px-8"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-12 gap-8 items-end">
        <div className="md:col-span-6">
          <div className="flex items-center gap-3">
            <span className="text-[#F5F5F5]"><Logo size={32} /></span>
            <span className="font-heading font-black tracking-tighter uppercase text-3xl sm:text-4xl">
              DISKO<span className="text-[#FF2A2A]">.</span>BHUTE
            </span>
          </div>
          <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#5A5A5A] mt-3">
            डिस्को भूते · The midnight sound
          </p>
        </div>
        <div className="md:col-span-3 font-mono text-[10px] tracking-[0.25em] uppercase space-y-2">
          <p className="text-[#8A8A8A]">Follow</p>
          <a
            data-testid="social-soundcloud"
            href="https://soundcloud.com/disko_bhute"
            target="_blank"
            rel="noopener noreferrer"
            className="block hover:text-[#FF2A2A] transition-colors"
          >
            ↗ SoundCloud
          </a>
          <a
            data-testid="social-instagram"
            href="https://instagram.com"
            target="_blank"
            rel="noopener noreferrer"
            className="block hover:text-[#FF2A2A] transition-colors"
          >
            ↗ Instagram
          </a>
          <a
            data-testid="social-youtube"
            href="https://www.youtube.com/@diskobhute"
            target="_blank"
            rel="noopener noreferrer"
            className="block hover:text-[#FF2A2A] transition-colors"
          >
            ↗ YouTube
          </a>
        </div>
        <div className="md:col-span-3 font-mono text-[10px] tracking-[0.25em] uppercase text-[#5A5A5A] md:text-right">
          © {year} Disko Bhute<br />
          All sounds reserved.
        </div>
      </div>
    </footer>
  );
}
